import {BaseService} from "./base.service";

class AffiliateTitularsService extends BaseService {

    constructor() {
        super('api/affiliates-titulars');
    }

    getSkuClient(role_id, sku) {
        //EL ROLE ID DEBE SER 0,8,9 QUE SON EL CONTRATANTE, AFILIADO T Y D
        return this.http.get(`api/get-sku-client/${role_id}/${sku}`).then(response => response.data).catch(err => err.message);
    }

    getTrashedAffiliates(params = {}) {
        return this.http.get(`api/get-trashed-affiliates`, {params}).then(response => response.data).catch(err => err.message);
    }

    restoreTitular(id) {
        return this.http.get(`api/restore-affiliate/${id}`).then(response => response.data).catch(err => err.message);
    }

    updateInfoBankAffiliate(id,data) {
        return this.http.post(`api/update-info-bank-affiliate/${id}`, data).then(response => response.data).catch(err => err.message);
    }

}

export const affiliateTitularsService = new AffiliateTitularsService();
